import React from "react";
import AsyncCreatableSelect from "react-select/async-creatable";
import {getComboListCbo} from "../../services/RequestService";
import selectStyles from "../../genericComponents/inputs/reactSelectStyles";

/**
 * Select com busca server-side na tabela de CBO (/cbo/combo-list?q=) a cada
 * digitação, que também permite digitar e ADICIONAR uma opção livre quando o
 * texto buscado não existe na lista.
 *
 * Trabalha apenas com a DESCRIÇÃO (texto) — não guarda o código do CBO:
 *
 * value    -> descrição/texto atualmente selecionado (string | null)
 * onChange -> (descricao) => void  — recebe a descrição escolhida ou digitada
 */
export default function CboAutoComplete({
  value,
  disabled,
  onChange,
  placeholder = "Digite para buscar ou adicionar...",
}) {
  // form-full converte valores nulos em "" ao aplicar actualValues, então "" também
  // conta como "sem seleção" (senão o react-select mostra um item vazio selecionado).
  const hasValue = value !== null && value !== undefined && value !== "";
  const selected = hasValue ? { value, label: value } : null;

  const loadOptions = async (input) => {
    if (!input || input.trim().length < 2) return [];
    const res = await getComboListCbo(input.trim());
    if (res.ok) {
      // guarda apenas a descrição: value e label passam a ser a própria descrição.
      return (res.data || []).map((o) => ({ value: o.label, label: o.label }));
    }
    return [];
  };

  return (
    <AsyncCreatableSelect
      cacheOptions
      value={selected}
      isDisabled={disabled}
      isClearable
      loadOptions={loadOptions}
      onChange={(opt) => onChange?.(opt ? opt.value : null)}
      placeholder={placeholder}
      formatCreateLabel={(input) => `Adicionar "${input}"`}
      loadingMessage={() => "Buscando..."}
      noOptionsMessage={({ inputValue }) =>
        inputValue && inputValue.trim().length >= 2
          ? "Nenhum resultado — digite para adicionar"
          : "Digite ao menos 2 caracteres"
      }
      menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
      menuPosition="fixed"
      styles={{ ...selectStyles, menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
    />
  );
}
